import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";

import CustomSelect from "@components/Forms/FormInputs/CustomSelect";

import { ICompanyTableControls } from "@store/filters/filter.types";
import { PopupActions } from "@store/popupStore";

const employeeSizeOptions = [
  {
    description: "0-99 employees",
    label: "Small",
    max: 99,
    min: 0,
  },
  {
    description: "100-999 employees",
    label: "Medium",
    max: 999,
    min: 100,
  },
  {
    description: "1,000-9,999 employees",
    label: "Large",
    max: 9999,
    min: 1000,
  },
  {
    description: "10,000+ employees",
    label: "Enterprise",
    max: Infinity,
    min: 10_000,
  },
];

interface IEmployeeSizeSelectProperties {
  onChange: (newState: ICompanyTableControls["filters"]) => void;
  value: string[];
}

function EmployeeSizeSelect({ onChange, value }: IEmployeeSizeSelectProperties) {
  const handleEmployeeSizeChange = (newSelectedSizes: string[]) => {
    if (newSelectedSizes.length === 0) {
      PopupActions.openAlert({
        duration: 4000,
        message: "Please select at least one employee size range.",
        severity: "error",
      });
      return;
    }

    const selectedEndpoints = newSelectedSizes.map((sizeLabel) => {
      const size = employeeSizeOptions.find((option) => option.label === sizeLabel);
      if (!size) {
        return { label: sizeLabel, max: Infinity, min: 0 };
      }
      return { label: size.label, max: size.max, min: size.min };
    });

    const minEndpoint = Math.min(...selectedEndpoints.map((size) => size.min));
    const maxEndpoint = Math.max(...selectedEndpoints.map((size) => size.max));

    const fullySelectedSizes = employeeSizeOptions
      .filter((option) => option.min >= minEndpoint && option.max <= maxEndpoint)
      .map((option) => option.label);

    onChange({ companyEmployeeSizes: fullySelectedSizes, maxEmployees: maxEndpoint, minEmployees: minEndpoint });
  };

  return (
    <CustomSelect
      clearIcon={<RestartAltRoundedIcon />}
      defaultSelectedOptions={employeeSizeOptions}
      formControlSx={{ width: "100%" }}
      getOptionLabel={(option) => `${option.label} (${option.description})`}
      getOptionValue={(option) => option.label}
      isMultiSelect={true}
      onChange={handleEmployeeSizeChange}
      options={employeeSizeOptions}
      selectedValues={value}
    />
  );
}

export default EmployeeSizeSelect;
